import { LayoutCanvas } from '../../types/types';
import { LAYOUT_FIXED_CANVAS_PADDING } from '../../constants';
import { getLayoutFixedCellSize } from './getLayoutFixedCellSize';

// Inverse of getLayoutFixedCell: canvas coordinates → index of the fixed-grid
// cell they fall into, clamped to the existing objects (drops past the last
// object land on it).
export const getLayoutFixedCellIndex = (
  canvas: LayoutCanvas,
  objectCount: number,
  x: number,
  y: number
): number => {
  // Cells sit inside the canvas padding — shift into grid coordinates.
  const relativeX = x - LAYOUT_FIXED_CANVAS_PADDING;
  const relativeY = y - LAYOUT_FIXED_CANVAS_PADDING;
  const { width: cellWidth, height: cellHeight } =
    getLayoutFixedCellSize(canvas);
  const gapX = canvas.gapX ?? 0;
  const gapY = canvas.gapY ?? 0;
  const hasColumns = !!canvas.columns && canvas.columns > 0;
  const hasRows = !!canvas.rows && canvas.rows > 0;
  const lastIndex = Math.max(0, objectCount - 1);

  if (hasRows && !hasColumns) {
    const rowCount = canvas.rows as number;
    const row = Math.min(
      Math.max(Math.floor(relativeY / (cellHeight + gapY)), 0),
      rowCount - 1
    );
    const column = Math.max(Math.floor(relativeX / (cellWidth + gapX)), 0);

    return Math.min(column * rowCount + row, lastIndex);
  }

  const columnCount = hasColumns && canvas.columns ? canvas.columns : 1;
  const column = Math.min(
    Math.max(Math.floor(relativeX / (cellWidth + gapX)), 0),
    columnCount - 1
  );
  const row = Math.max(Math.floor(relativeY / (cellHeight + gapY)), 0);

  return Math.min(row * columnCount + column, lastIndex);
};
